import { MenuItem, VueRouter } from "@abaco/web-common/src/app";
const agricolus_url = "https://www.agricolus.com/";
const sialleva_url = "https://www.sialleva.it/";

export function createMenu(router: VueRouter): MenuItem[] {
    return [
        {
            id: "import-company",
            descrKey: "import-company",
            icon: "fa fa-download",
            onClick: () => router.push({ name: "import-company" }),
            get isVisible() {
                return true;
            },
        },
        {
            id: "import-company-v2",
            descrKey: "import-company-v2",
            icon: "fa fa-download",
            onClick: () => router.push({ name: "import-company-v2" }),
            get isVisible() {
                return true;
            },
        },
        {
            id: "activation-form",
            descrKey: "activation-form",
            icon: "fa fa-light-switch",
            onClick: () => router.push({ name: "activation-form" }),
            get isVisible() {
                return true;
            },
        },
        {
            id: "help-coldiretti",
            descrKey: "help-coldiretti",
            icon: "fa fa-info",
            onClick: () => router.push({ name: "help-coldiretti" }),
            get isVisible() {
                return true;
            },
        },
        {
            id: "system-monitoring",
            descrKey: "system-monitoring",
            icon: "fa fa-heartbeat",
            onClick: () => router.push({ name: "system-monitoring" }),
            get isVisible() {
                return true;
            },
        },
        {
            id: "gias-qdc",
            descrKey: "gias-qdc",
            icon: "abc-icon abc-icon-paper text-black",
            onClick: () => router.push({ name: "gias-qdc" }),
            get isVisible() {
                return true;
            },
        },
        {
            id: "gias-qdc-new",
            descrKey: "gias-qdc-new",
            icon: "abc-icon abc-icon-paper text-black",
            onClick: () => router.push({ name: "gias-qdc-new" }),
            get isVisible() {
                return true;
            },
        },
        {
            id: "agricolus-sogg-home",
            descrKey: "agricolus-home",
            icon: "fa-sharp fa-solid fa-a",
            onClick: () => window.open(agricolus_url),
            get isVisible() {
                return true;
            },
        },
        {
            id: "sialleva-sogg-home",
            descrKey: "sialleva-home",
            icon: "fa-solid fa-cow",
            onClick: () => window.open(sialleva_url),
            get isVisible() {
                return true;
            },
        },
    ];
}
